import Vue from 'vue'

export const mutations = {
  updateAttributes: (state, payload) => {
    const { presentationId, slideId, attributes } = payload
    if (!state[presentationId]) {
      Vue.set(state, presentationId, {})
    }
    if (!state[presentationId][slideId]) {
      Vue.set(state[presentationId], slideId, {})
    }
    Object.assign(state[presentationId][slideId], attributes)
  },
}
